import { useEffect } from "react";
import { IFrameEvents } from "../constants/enum/iframe";

const useIFrameEvent = (
  iframeRef: React.RefObject<HTMLIFrameElement> | undefined,
  eventHandler: (eventName: IFrameEvents, eventParam: any) => void
) => {
  useEffect(() => {
    const handleEvent = (event: MessageEvent) => {
      if (
        iframeRef?.current &&
        event.source === iframeRef.current.contentWindow
      ) {
        const { eventName, eventParam } = event.data;
        eventHandler(eventName, eventParam);
      }
    };

    window.addEventListener("message", handleEvent);

    return () => {
      window.removeEventListener("message", handleEvent);
    };
  }, [iframeRef, eventHandler]);
};

export default useIFrameEvent;
